import { Message } from "@/modules/staff/objects/conversation/Message";
import { QcUnreadMessage } from "@/modules/staff/objects/conversation/QcUnreadMessage";

export enum EventType {
  OnCreateMessage = "createMessageViaApi",
  OnUpdateMessage = "updateMessageViaApi",
  OnCreateQcUnreadMessage = "createQcUnreadMessage",
  OnDeleteQcUnreadMessage = "deleteQcUnreadMessage",
  OnReadConversation = "readConversation",
  OnUpdateConversationState = "updateConversationState",
  OnNotifyMyself = "notifyMyself",
  OnChangeUser = "changeUser",
  OnNotifyInquiry = "notifyInquiry",
  Test = "test",
  OnCreateSandbox = "createSandbox",
  OnApplySandbox = "applySandbox",
  OnCreateQcUnreadConversation = "createQcUnreadConversation", // to make conversation's title bold for new incoming message from guest
  OnStartVoiceChatInRoom = "startVoiceChatInRoom",
  OnRespondVoiceChatInRoom = "respondVoiceChatInRoom",
  OnFinishVoiceChatInRoom = "finishVoiceChatInRoom",
  OnCreateQcUnrepliedConversation = "createQcUnrepliedConversation", // to show green dot next to the conversation
  OnChatTyping = "chatTyping",
  OnDisplayNewIcon = "displayNewIcon",
}

/**
 * The general Kotozna event that is received from the Kotozna backend.
 * It contains all kind of stringified Kotozna events (`event_value`) as well as additional data.
 */
export type NotifyMyEvent = {
  user_access_id: string;
  conversation_id: string;
  tenant_id: string;
  event_id: number;
  event_type: string;
  event_value: string;
};

export type ReadConversation = {
  conversation_id: string;
  unread_messages: [QcUnreadMessage];
  read_user: ReadUser;
  read_at: string;
};

type ReadUser = {
  id_account: number;
  access_id: string;
  name: string;
  lang_cd: string;
  icon: string;
  user_type: string;
  qr: string;
  sign_up_at: string;
};

export type ChangeUser = {
  userAccessId: string;
};

export type NotifyMyself = {
  user_access_id: string;
  event_type: string;
  event_value: [string];
};

export type ConversationState = {
  conversation_id: string;
  notice_user_access_id: string;
  conversation_state: string | null;
  live_chat_strategy?: string | null;
  machine_translated?: boolean | null;
};

export type SandboxResult = {
  result: string;
  message: string;
};

export type CreateQcUnreadConversation = {
  sender_user_id: string;
  conversation_id: string;
  last_talk_at: string;
};

export type CreateQcUnrepliedConversation = {
  sender_user_id: string;
  conversation_id: string;
  last_talk_at: string;
};

export type OnStartVoiceChatInRoom = {
  session_id: string;
  src_user_id: string;
};

export type OnRespondVoiceChatInRoom = {
  session_id: string;
  action: string;
  respond_user_id: string;
};
